import React from "react";
import {Box} from "@mui/material";
import Machine from "./machine";
import {getUrlVars} from "../utils/systemInfo";

function MachineCompare() {
    const {deviceId, device2Id} = getUrlVars();
    return (
        <Box sx={{display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "1rem"}}>
            <Machine compare deviceId={deviceId} />
            <Machine compare deviceId={device2Id} device2 />
        </Box>
    );
}
export default MachineCompare;
